import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import BN_TreatmentPlanCategoryModalityCitation from '@/fhirworks/BN_TreatmentPlanCategoryModalityCitation';

export default class BN_TreatmentPlanCategoryModality extends BackboneElement {
    static __className = 'BN_TreatmentPlanCategoryModality';

    __objectStructure = {
        modal: String,
        display: String, // Free-text human name for in-app authored theoretical models
        level: [Number], // Array of numbers to support multiple levels
        source: [BN_TreatmentPlanCategoryModalityCitation], // Structured citations
        reference: [BN_TreatmentPlanCategoryModalityCitation], // Where objectives/interventions were derived from
        narrative: String, // Extra explanatory text that appears before the sources/references
    };

    constructor(constructJson, className = 'BN_TreatmentPlanCategoryModality') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        // getJsonForStructure -> removeUndefinedObjProps already drops empty source/reference
        // arrays (Aidbox/FHIR rejects empty arrays), so no extra guard is needed here.
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
